import { StudentReadingLevelResponse } from "@/reports/types";

export const studentReadingLevelMockData: StudentReadingLevelResponse = {
  data: {
    filters_applied: {
      min_date: "2024-08-01",
      max_date: "2025-01-31",
      entity_type: "student",
      entity_id: "4bbdf574063e493ca0f059528205d40j",
      only_assigned_content: true,
    },
    data: {
      article_grade_level_viewed_average: 5,
      article_lexile_level_viewed_average: "762L",
      articles_viewed_count: 25,
      article_time_average: 10,
      student_quiz_level_equivalence_median: "equal",
    },
  },
};

export const studentReadingLevelNoActivityMockData: StudentReadingLevelResponse =
  {
    data: {
      filters_applied: {
        min_date: "2024-08-01",
        max_date: "2025-01-31",
        entity_type: "student",
        entity_id: "4bbdf574063e493ca0f059528205d40j",
        only_assigned_content: true,
      },
      data: {
        article_grade_level_viewed_average: 0,
        article_lexile_level_viewed_average: "0L",
        articles_viewed_count: 0,
        article_time_average: 0,
        student_quiz_level_equivalence_median: "below",
      },
    },
  };
